import React, { useEffect, useState } from "react";
import {
  selectLocationsByState,
  useGetLocationsQuery,
} from "../features/rapidstor/rapidstorApiSlice";
import { useSelector } from "react-redux";
import LocationCard from "./LocationCard";
import SmallHeader from "./SmallHeader";
import BigHeader from "./BigHeader";
import Map from "./Map";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import StateSelector from "./StateSelector";
import classes from "./LocationCard.module.scss";
import Card from "react-bootstrap/Card";
import MediumHeader from "./MediumHeader";
import SmallDetail from "./SmallDetail";
import store from "../store";
import { setStartTime } from "../store/bookingSlice";
import { options } from "../services/rapidstor";

function LocationSelector() {
  const { isLoading, error, refetch } = useGetLocationsQuery();
  const [region, setRegion] = useState<string>("");
  const locations = useSelector((state) => selectLocationsByState(state, region));

  useEffect(() => {
    store.dispatch(setStartTime(null));
  }, []);

  let content;

  if (isLoading && locations.length === 0) {
    content = <Col>Loading locations...</Col>;
  } else if (error) {
    content = (
      <Col>
        <Alert>
          Sorry, we were unable to load the list of facilities.
          <div className={"mt-2"}>
            <Button onClick={refetch}>Retry</Button>
          </div>
        </Alert>
      </Col>
    );
  } else if (locations.length === 0) {
    content = (
      <Col lg={6}>
        <Card className={`${classes.card} ${classes.expanded}`}>
          <Card.Body className={classes.cardBody}>
            <div className={classes.facilityInfo}>
              <MediumHeader className={classes.name}>Locations coming soon</MediumHeader>
              <SmallDetail className={classes.address}>
                There are currently no locations in {region || "Australia"}, but they will
                be coming soon.
              </SmallDetail>
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  } else {
    content = locations.map((location) => (
      <Col lg={6} key={location.locationCode}>
        <Link to={`/locations/${location.slug}`} className="hidden-link">
          <LocationCard locationCode={location.locationCode} />
        </Link>
      </Col>
    ));
  }

  return (
    <>
      <SmallHeader className={"mt-3 mb-3"}>Book A Unit</SmallHeader>
      <BigHeader>Select your preferred location</BigHeader>
      {!options.enabledLocations.includes("L005") && (
        <StateSelector region={region} onChange={(region) => setRegion(region)} />
      )}

      <Row>{content}</Row>
      {locations.length > 0 && (
        <>
          <Row className={"mt-2 mb-2"}>
            <Col>
              <SmallHeader>Map</SmallHeader>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <a
                className="link transparent"
                href={`https://www.google.com/maps/search/${
                  options.enabledLocations.includes("L005") ? "Welshpool" : "KeepSafe"
                }"+Storage",+Australia/`}
                target={"_blank"}
                rel="noreferrer"
              >
                View in Maps
              </a>
            </Col>
          </Row>
          <Row>
            <Col>
              <Map region={region} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default LocationSelector;
